import { render, staticRenderFns } from "./ModuleSelector.vue?vue&type=template&id=6001cbfc&scoped=true"
import script from "./ModuleSelector.vue?vue&type=script&lang=js"
export * from "./ModuleSelector.vue?vue&type=script&lang=js"
import style0 from "./ModuleSelector.vue?vue&type=style&index=0&id=6001cbfc&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6001cbfc",
  null
  
)

export default component.exports